// extracted by mini-css-extract-plugin
export default {"module":"StarRating_module__RYMrk","stars":"StarRating_stars__QNzcy","star":"StarRating_star__K52jv","score":"StarRating_score__atGU7"};